import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    tableHeader: {
        backgroundColor: theme.palette.emteria.background.tableHeaders,
        "& .MuiTableCell-root": {
            color: theme.palette.emteria.text.inverse,
            fontWeight: "bold",
        },
    },
    loadingContainer: {
        height: "50px",
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    text: {
        textAlign: "center",
    },
    buttonBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
        height: 50,
    },
    collapseBtn: {
        "&:focus": {
            outline: "none",
        },
    },
    collapsingRowContent: {
        padding: theme.spacing(2),
        width: "100%",
        maxWidth: "100%",
        minHeight: 36,
        textAlign: "left",
        wordWrap: "break-word",
    },
    collapsePropertyTitle: {
        fontWeight: "bold",
    },
    borderBottomVisible: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    },
    overflow: {
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    headerContainer: {
        display: "flex",
        justifyContent: "space-between",
    },
    headerBox: { display: "flex", justifyContent: "space-between", paddingBottom: theme.spacing(2) },
    btnBox: { display: "flex", gap: theme.spacing(1) },
    tagsBox: {
        overflowY: "auto",
        maxWidth: 400,
        maxHeight: 70,
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        padding: theme.spacing(1),
    },
}));
